import { useEffect } from 'react';

export function useOverrideReconciliation(
  portfolioAllocations: any[] | undefined,
  setOverrides: React.Dispatch<React.SetStateAction<Record<string, number>>>
) {
  useEffect(() => {
    const dbAllocations = portfolioAllocations || [];
    if (!dbAllocations.length) return;
    setOverrides((prev) => {
      if (!prev || Object.keys(prev).length === 0) return prev;
      const next = { ...prev } as Record<string, number>;
      for (const a of dbAllocations as any[]) {
        const id: string | undefined = a?.id;
        if (!id) continue;
        const ov = prev[id];
        if (ov === undefined) continue;
        const dbPct = Number(a?.allocation_percentage ?? 0);
        if (!Number.isFinite(dbPct)) continue;
        if (Math.abs(dbPct - ov) < 0.005) {
          delete next[id];
        }
      }
      return next;
    });
  }, [portfolioAllocations, setOverrides]);
}
